import { GrowlerKind } from "@spscommerce/ds-shared";
import * as React from "react";

import { ReactNodeOrRenderFn } from "../prop-types";
import { contentOf } from "../utils/contentOf";
import { SpsGrowler } from "./SpsGrowler";

export interface GrowlerConfig {
    title: string;
    content: ReactNodeOrRenderFn;
    kind?: GrowlerKind;
    imgSrc?: string;
    onClose?: () => void;
    closed?: boolean;
}

export function useGrowlers(): [() => JSX.Element[], (config: GrowlerConfig) => void] {
    const [growlerList, setGrowlerList] = React.useState<Array<GrowlerConfig>>([]);

    const growlers = React.useCallback(function ()  {
        return growlerList.map((g, i) =>
            <SpsGrowler key={i} title={g.title} kind={g.kind} imgSrc={g.imgSrc}
                onClose={() => {
                    if (g.onClose) {
                        g.onClose();
                    }
                    g.closed = true;
                    if (growlerList.every(r => r.closed)) {
                        setGrowlerList([]);
                    }
                }}>{
                contentOf(g.content)
            }</SpsGrowler>
        );
    }, [growlerList]);

    const createGrowler = React.useCallback(function (config: GrowlerConfig) {
        config.kind = config.kind || GrowlerKind.INFO;
        setGrowlerList((currentGrowlerList) => [...currentGrowlerList, config]);
    }, []);

    return [growlers, createGrowler];
}
